import type { HourlyWeatherPrediction } from "@pentacode/core";

export function aggregateHourly(data: readonly HourlyWeatherPrediction[]) {
    const croppedData = data.slice(2, data.length - 2);
    const aggregatedData: HourlyWeatherPrediction[] = [];
    for (let i = 0; i < croppedData.length; i += 3) {
        const chunk = croppedData.slice(i, i + 3);
        const avgTemperature = chunk.reduce((sum, d) => sum + d.temperature, 0) / chunk.length;
        const totalPrecipitation = chunk.reduce((sum, d) => sum + d.precipitation.amount, 0);
        const maxPrecipitationProbability = Math.max(...chunk.map((d) => d.precipitation.propability));
        const avgWindSpeed = chunk.reduce((sum, d) => sum + d.windSpeed, 0) / chunk.length;
        aggregatedData.push({
            ...chunk[Math.floor(chunk.length / 2)]!,
            temperature: avgTemperature,
            precipitation: {
                amount: totalPrecipitation,
                propability: maxPrecipitationProbability,
            },
            windSpeed: avgWindSpeed,
        });
    }
    return aggregatedData;
}
